/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */
export const SET_ROTATIONAL_BANNER_DATA = 'set rotational  banners data';
